import './ProgressBar.scss';

export type ProgressBarSize = 'sm' | 'md';
export type ProgressBarVariant = 'determinate' | 'indeterminate';

export interface ProgressBarProps {
  value?: number;
  variant?: ProgressBarVariant;
  size?: ProgressBarSize;
  ariaLabel?: string;
  className?: string;
}

const clamp = (n: number): number => {
  if (Number.isNaN(n)) return 0;
  if (n < 0) return 0;
  if (n > 100) return 100;
  return n;
};

const ProgressBar = ({ value = 0, variant = 'determinate', size = 'sm', ariaLabel, className }: ProgressBarProps) => {
  const isIndeterminate = variant === 'indeterminate';
  const safeValue = clamp(value);
  const rootClass = [
    'progress-bar',
    `progress-bar--size-${size}`,
    isIndeterminate ? 'progress-bar--indeterminate' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  const ariaProps = isIndeterminate
    ? { role: 'progressbar' as const, 'aria-label': ariaLabel }
    : {
        role: 'progressbar' as const,
        'aria-label': ariaLabel,
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': safeValue
      };

  return (
    <div className={rootClass} {...ariaProps}>
      <div className="progress-bar__track">
        <div className="progress-bar__fill" style={isIndeterminate ? undefined : { width: `${safeValue}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
